export const PATHS = {
    LOGIN: '/',
};
